export const DAY_REINITIALIZE = 26;
export const WITHOUT_TRANSMIT = 'Sin transmitir';
export const TRANSMIT = 'TRANSMITIDO';
export const FINALIZED = 'FINALIZADO';
